import React, { useState, useReducer, useEffect, useRef } from "react";
import { Button, Grid, Modal, Icon, Popup, Label } from "semantic-ui-react";
import {
  initialState,
  reducer,
  ACTION,
} from "../../../Reducer/InitialStateReducer";

import { server } from "../../../App";
import axios from "axios";
import {
  columnDefs_Ordo_Examen_Comp,
  defaultColDef_Ordo_Examen_Comp,
} from "./GridParam_Ordo_Examen_Comp/GridParams";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

import moment from "moment";

import { Editor } from "@tinymce/tinymce-react";
import { useSelector, useDispatch } from "react-redux";
import { selectCounters, ExamenCompl_Counter_Reducer } from "../../../features/counter/counterSlice";


function Note(props) {
  const dispatchRedux = useDispatch();
  const CountersState = useSelector(selectCounters);
  const [state, dispatch] = useReducer(reducer, initialState);
  const [dateExam, setDateExam] = useState("");
  const { ID, userInformation } = props;

  // ag grid state
  const [, setGridApi] = useState(null);
  const [, setGridColumnApi] = useState(null);

  const editorRef = useRef(null);

  // this is the history of examens Complementaire
  async function GetAllExamenCompl() {
    await axios
      .get(`${server}Consultation/ExamenCompl/${ID}`, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => {
        dispatchRedux(ExamenCompl_Counter_Reducer(response.data.length));
        dispatch({ type: ACTION.FETCH_SUCCESS2, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: "FETCH_ERROR", payload: error.response });
      });
  }

  useEffect(() => {
    // getOneUser();
    GetAllExamenCompl();
  }, [state.open]);

  const onGridReady = (params) => {
    setGridColumnApi(params.columnApi);
    setGridApi(params.api);
  };
  let dateAujourdhui = moment().format("YYYY-MM-DD");
  const onSelectionChanged2 = (e) => {
    if (e.api.getSelectedRows()[0] === undefined) {
      const emptyCheckbox = {
        idExamens_Compl: "",
        nom_Examens_Compl: "",
        fk_id_patient_examen_compl: "",
        date_exam_compl: "",
        date_exam_compl_converted: "",
      };
      setDateExam("");
      dispatch({
        type: ACTION.LOAD_History_examen_compl,
        value: emptyCheckbox,
      });
    } else {
      let clientArray = e.api.getSelectedRows()[0];
      let dateModificationExamenCompl = moment(
        clientArray.dateModification
      ).format("YYYY-MM-DD");
      setDateExam(
        dateModificationExamenCompl === "Invalid date"
          ? dateAujourdhui
          : dateModificationExamenCompl
      );

      dispatch({
        type: ACTION.LOAD_History_examen_compl,
        value: clientArray,
      });
    }
  };

  const onCellValueChanged2 = async ({ data }) => {
    axios({
      method: "put",
      responseType: "json",
      url: `${server}Consultation/ExamenCompl`,
      data: data,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        dispatch({
          type: ACTION.FETCH_SUCCESS2,
          payload: response.data,
        });
        // GetAllExamenCompl();
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };
  const ModTimeExam = async () => {
    // { fk_id_patient_examen_compl, idExamens_Compl, nom_Examens_Compl, date_exam_compl,dateModification }

    const dataToupdate = {
      idExamens_Compl: state.idExamens_Compl,
      nom_Examens_Compl: editorRef.current.getContent(),
      fk_id_patient_examen_compl: state.fk_id_patient_examen_compl,
      dateModification: dateExam,
    };

    axios({
      method: "put",
      responseType: "json",
      url: `${server}Consultation/ExamenCompl`,
      data: dataToupdate,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        dispatch({
          type: ACTION.FETCH_SUCCESS2,
          payload: response.data,
        });
        // GetAllExamenCompl();
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  const handleRemoveItem12 = async () => {
    axios({
      method: "DELETE",
      responseType: "json",
      url: `${server}Consultation/ExamenCompl/${state.idExamens_Compl}/${state.fk_id_patient_examen_compl}/ExamenCompl`,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then(() => {
        dispatch({ type: ACTION.DELETE_SUCCESS });
        GetAllExamenCompl();
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  let res = state?.nom_Examens_Compl?.replace(/\n/g, "<br/>");
  //  editorRef.current.getContent()
  // console.log(res);

  let resultAfterFilter;
  let isafter = moment(state.date_exam_compl).isAfter("2022-02-15T00:00:00Z");
  if (isafter) {
    resultAfterFilter = state?.nom_Examens_Compl;
  } else {
    resultAfterFilter =
      `<h4 style="text-align: center;"${state?.date_exam_compl_converted
        ? state?.date_exam_compl_converted
        : ".../.../......"
      }</h4>
          <h4 style="text-align: center;">${userInformation.civilite} ${userInformation.nom
      }
          ${userInformation.prenom}</h4>` + res;
  }

  let Contents = (
    <div>
      <Editor
        // apiKey="4wmks1hxrd175lnu674946w8nb95pzv263exeq2v73z02al0"
        tinymceScriptSrc={process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"}
        onInit={(evt, editor) => (editorRef.current = editor)}
        initialValue={resultAfterFilter}
        init={{
          // selector: "textarea",
          branding: false,
          height: "81.5vh",
          menubar: false,
          plugins: [
            "advlist autolink lists link image charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table paste code help ",
            "print",
          ],
          toolbar:
            "undo redo | bold italic underline forecolor backcolor print",
          content_style:
            "@page { size: A5;margin-top: 3.8cm; margin-bottom: 2.2cm; margin-left:0.25cm; margin-right:0.25cm;} body{font-size:16px} ",
        }}
      />
    </div>
  );

  return (
    <>
      {/* diagn */}
      <Popup
        content="historique Examen compl"
        trigger={
          <Button
            // color="teal"

            onClick={() => dispatch({ type: ACTION.OPEN, size: "fullscreen" })}
          >
            <Icon name="history" size="large" className="centerIcon" />
            {CountersState?.ExamenCompl_Counter === 0 ? null :
              <Label color='red' className="floatingnumber">
                {CountersState?.ExamenCompl_Counter}
              </Label>

            }
          </Button>
        }
      />

      <Modal
        size={state.size}
        open={state.open}
        onClose={() => {
          dispatch({ type: ACTION.CLOSE });
        }}
        className="lunettesModal"
      >
        <Modal.Header className="center3columnheaders">
          historique
          {/* <Button
            floated="left"
            color="blue"
            onClick={() => {
              dispatch({ type: ACTION.CLOSE });
            }}
          >
            Retour
          </Button> */}
          <Button
            floated="right"
            color="blue"
            onClick={() => dispatch({ type: ACTION.CLOSE })}
          >
            Retour <Icon className="leftSpace" name="reply" />
          </Button>
          {isafter ? (
            <Button
              floated="right"
              color="orange"
              onClick={() => ModTimeExam()}
            >
              Modifier
            </Button>
          ) : (
            <Button
              disabled
              floated="right"
              color="orange"
            // onClick={() => ModTimeExam()}
            >
              Modifier
            </Button>
          )}
          <input
            // key={999}
            style={{ float: "left" }}
            type="date"
            defaultValue={dateExam}
            onChange={(e) => setDateExam(e.target.value)}
          />
        </Modal.Header>
        <Modal.Content>
          <Grid>
            <Grid.Column width={10}>{Contents}</Grid.Column>
            {/* <Grid.Column width={6}>
              <div
                id="myGrid"
                className="ag-theme-alpine"
                style={{
                  height: "60vh",
                  width: "100%",
                }}
              >
                <AgGridReact
                  rowSelection={"multiple"}
                  rowData={state.rowData ? state.rowData : []}
                  animateRows={true}
                  sortingOrder={["desc", "asc", null]}
                  onGridReady={onGridReady}
                  columnDefs={columnDefs}
                  defaultColDef={defaultColDef}
                  // rowSelection={"single"}
                  onSelectionChanged={onSelectionChanged}
                  undoRedoCellEditing={true}
                  undoRedoCellEditingLimit={40}
                  onCellValueChanged={onCellValueChanged}
                ></AgGridReact>
              </div>
              <br />
              {state.id_detail_1 ? (
                <Button
                  negative
                  onClick={handleRemoveItem1}
                  floated="right"
                  icon
                >
                  <Icon name="delete" />
                </Button>
              ) : (
                <Button disabled negative floated="right" icon>
                  <Icon name="delete" />
                </Button>
              )}
            </Grid.Column> */}
            <Grid.Column width={6}>
              <div
                id="myGrid"
                className="ag-theme-alpine"
                style={{
                  height: "60vh",
                  width: "100%",
                }}
              >
                <AgGridReact
                  rowData={state.rowData2 ? state.rowData2 : []}
                  animateRows={true}
                  sortingOrder={["desc", "asc", null]}
                  onGridReady={onGridReady}
                  columnDefs={columnDefs_Ordo_Examen_Comp}
                  defaultColDef={defaultColDef_Ordo_Examen_Comp}
                  rowSelection={"single"}
                  onSelectionChanged={onSelectionChanged2}
                  undoRedoCellEditing={true}
                  undoRedoCellEditingLimit={40}
                  onCellValueChanged={onCellValueChanged2}
                ></AgGridReact>
              </div>
              <br />
              {state?.idExamens_Compl ? (
                <Button
                  negative
                  onClick={handleRemoveItem12}
                  floated="right"
                  icon
                >
                  Supprimer définitivement
                </Button>
              ) : (
                <Button
                  disabled
                  negative
                  // onClick={handleRemoveItem12}
                  floated="right"
                  icon
                >
                  Supprimer définitivement
                </Button>
              )}
            </Grid.Column>
          </Grid>
        </Modal.Content>
      </Modal>
    </>
  );
}

export default Note;
